var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 54,
    viewBox: "0 0 62 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7109 1.48438C15.2578 0.703125 16 0.3125 16.9375 0.3125H45.0625C46 0.3125 46.7422 0.703125 47.2891 1.48438L60.4141 19.2969C61.1953 20.5469 61.1563 21.7188 60.2969 22.8125L33.1094 52.8125C32.5625 53.4375 31.8594 53.75 31 53.75C30.1406 53.75 29.4375 53.4375 28.8906 52.8125L1.70312 22.8125C0.84375 21.7188 0.804688 20.5469 1.58594 19.2969L14.7109 1.48438ZM19.1641 6.17188C18.7734 6.48438 18.6953 6.875 18.9297 7.34375L25.7266 18.5938L8.38281 20C7.91406 20.0781 7.64062 20.3906 7.5625 20.9375C7.64062 21.4844 7.91406 21.7969 8.38281 21.875L30.8828 23.75C30.9609 23.75 31 23.75 31 23.75C31 23.75 31.0391 23.75 31.1172 23.75L53.6172 21.875C54.0859 21.7969 54.3594 21.4844 54.4375 20.9375C54.3594 20.3906 54.0859 20.0781 53.6172 20L36.3906 18.5938L43.0703 7.34375C43.3047 6.875 43.2266 6.48438 42.8359 6.17188C42.3672 5.85937 41.9375 5.89844 41.5469 6.28906L31 17.6562L20.4531 6.28906C20.0625 5.89844 19.6328 5.85937 19.1641 6.17188Z",
    fill: "url(#paint0_linear_469_51125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_469_51125",
    x1: 33,
    y1: -3,
    x2: 33,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.a9c99f79.svg";
export { ForwardRef as ReactComponent };